// extracted by mini-css-extract-plugin
export default {"control":"control_control__ll5pQ","button":"control_button__ETmAt"};